import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './common/footer/footer.component';
import { Select } from '@ngxs/store';
import { AppState, AppStateModel } from './app.state';
import { Observable } from 'rxjs';
import { WINDOW } from './common/services/injection-tokens';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CkEditorService } from './common/services/ck-editor.service';

@UntilDestroy()
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router,
    @Inject(WINDOW) private _window: Window | null,
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private _ckEditorService: CkEditorService,
  ) {}

  @Select(AppState)
  protected appState$!: Observable<AppStateModel>;

  @ViewChild('contentContainer')
  protected contentContainer?: ElementRef<HTMLElement>;

  public ngOnInit(): void {
    this._ckEditorService.preloadCKEditor().catch(error => {
      console.warn('Failed to preload CK Editor:', error);
    });

    this._router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.contentContainer?.nativeElement?.scrollTo?.(<any>{ top: 0, left: 0, behavior: 'instant' });

        this._window?.scrollTo?.(<any>{ top: 0, left: 0, behavior: 'instant' });
      });
  }
}
